import { Link } from "react-router-dom";
import { SEO } from "@/components/SEO";
import { FadeIn } from "@/components/FadeIn";
import { RevealHeading } from "@/components/RevealHeading";

export default function ThankYou() {
  return (
    <div data-testid="thank-you-page" className="min-h-screen flex items-center justify-center pt-20 pb-20">
      <SEO title="Thank You" description="Your information has been received by DULORME LABS." path="/thank-you" />
      <div className="container-custom text-center max-w-xl">
        <RevealHeading
          tag="h1"
          lines={["THANK YOU."]}
          className="font-display font-black text-5xl sm:text-6xl tracking-tight text-white"
        />
        <FadeIn delay={0.3}>
          <p className="mt-8 text-base md:text-lg text-zinc-400 leading-relaxed">
            Your information has been received. The DULORME LABS team will review your business and contact you regarding the next step.
          </p>
          <Link
            to="/"
            data-testid="thank-you-home-link"
            className="mt-10 inline-flex items-center gap-2 border border-white/20 text-white text-xs font-bold tracking-widest uppercase px-8 py-4 hover:bg-white/10 transition-colors duration-300"
          >
            Back To Home
          </Link>
        </FadeIn>
      </div>
    </div>
  );
}
